export const defaultPowerDatas = [
  {
    id: 1,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{}',
    created_at: '2022-11-21T13:02:56.000Z',
    updated_at: null,
  },
  {
    id: 2,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.3000030517578,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.093992233276367,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.7718374133110046,\n    "phase_angle": 0.0,\n    "frequency": 60.02000045776367,\n    "import_energy_active": 1097.9830322265625,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.2930297851562,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 7.2781081199646,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 7.2781081199646,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.03551442176103592,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1219482421875,\n    "total_energy_reactive": 544.9310302734375\n}',
    created_at: '2022-11-21T13:14:55.000Z',
    updated_at: null,
    voltage: 224.3000030517578,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.093992233276367,
    power_reactive: 6.800000190734863,
    power_factor: 0.7718374133110046,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 1097.9830322265625,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.2930297851562,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 7.2781081199646,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 7.2781081199646,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.03551442176103592,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1219482421875,
    total_energy_reactive: 544.9310302734375,
  },
  {
    id: 3,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.39999389648438,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.042264938354492,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.7646205425262451,\n    "phase_angle": 0.0,\n    "frequency": 59.95000076293945,\n    "import_energy_active": 1097.9830322265625,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.2930297851562,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 7.2781081199646,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 7.2781081199646,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.03551442176103592,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1219482421875,\n    "total_energy_reactive": 544.9310302734375\n}',
    created_at: '2022-11-21T13:14:59.000Z',
    updated_at: null,
    voltage: 224.39999389648438,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.042264938354492,
    power_reactive: 6.800000190734863,
    power_factor: 0.7646205425262451,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 1097.9830322265625,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.2930297851562,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 7.2781081199646,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 7.2781081199646,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.03551442176103592,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1219482421875,
    total_energy_reactive: 544.9310302734375,
  },
  {
    id: 4,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.39999389648438,\n    "current": 0.03999999910593033,\n    "power_active": 8.0,\n    "power_apparent": 11.02056884765625,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7551398277282715,\n    "phase_angle": 0.0,\n    "frequency": 60.02000045776367,\n    "import_energy_active": 1097.9830322265625,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.2930297851562,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 7.2781081199646,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 7.2781081199646,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.03551442176103592,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1219482421875,\n    "total_energy_reactive": 544.9310302734375\n}',
    created_at: '2022-11-21T13:15:03.000Z',
    updated_at: null,
    voltage: 224.39999389648438,
    current: 0.03999999910593033,
    power_active: 8,
    power_apparent: 11.02056884765625,
    power_reactive: 7.199999809265137,
    power_factor: 0.7551398277282715,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 1097.9830322265625,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.2930297851562,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 7.2781081199646,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 7.2781081199646,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.03551442176103592,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1219482421875,
    total_energy_reactive: 544.9310302734375,
  },
  {
    id: 5,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.5,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.10068130493164,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.7667957544326782,\n    "phase_angle": 0.0,\n    "frequency": 59.95000076293945,\n    "import_energy_active": 1097.9830322265625,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.2930297851562,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 7.2781081199646,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 7.2781081199646,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.03551442176103592,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1219482421875,\n    "total_energy_reactive": 544.9310302734375\n}',
    created_at: '2022-11-21T13:15:07.000Z',
    updated_at: null,
    voltage: 224.5,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.10068130493164,
    power_reactive: 6.800000190734863,
    power_factor: 0.7667957544326782,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 1097.9830322265625,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.2930297851562,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 7.2781081199646,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 7.2781081199646,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.03551442176103592,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1219482421875,
    total_energy_reactive: 544.9310302734375,
  },
  {
    id: 7,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.5,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.140209197998047,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.7669463157653809,\n    "phase_angle": 0.0,\n    "frequency": 59.95000076293945,\n    "import_energy_active": 1097.9830322265625,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.2930297851562,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 7.2781081199646,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 7.2781081199646,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.03551442176103592,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1219482421875,\n    "total_energy_reactive": 544.9310302734375\n}',
    created_at: '2022-11-21T13:15:12.000Z',
    updated_at: null,
    voltage: 224.5,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.140209197998047,
    power_reactive: 6.800000190734863,
    power_factor: 0.7669463157653809,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 1097.9830322265625,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.2930297851562,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 7.2781081199646,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 7.2781081199646,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.03551442176103592,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1219482421875,
    total_energy_reactive: 544.9310302734375,
  },
  {
    id: 8,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 226.3000030517578,\n    "current": 0.04399999976158142,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.318883895874023,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7539966106414795,\n    "phase_angle": 0.0,\n    "frequency": 59.880001068115234,\n    "import_energy_active": 1098.0030517578125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 8.205999374389648,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 8.205999374389648,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.04051331803202629,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1419677734375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-21T15:28:11.000Z',
    updated_at: null,
    voltage: 226.3000030517578,
    current: 0.04399999976158142,
    power_active: 8.399999618530273,
    power_apparent: 11.318883895874023,
    power_reactive: 7.199999809265137,
    power_factor: 0.7539966106414795,
    phase_angle: 0,
    frequency: 59.880001068115234,
    import_energy_active: 1098.0030517578125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 8.205999374389648,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 8.205999374389648,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.04051331803202629,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1419677734375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 9,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 226.5,\n    "current": 0.04399999976158142,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.33243179321289,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.745516836643219,\n    "phase_angle": 0.0,\n    "frequency": 59.880001068115234,\n    "import_energy_active": 1098.0030517578125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 8.205999374389648,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 8.205999374389648,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.04051331803202629,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1419677734375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-21T15:28:17.000Z',
    updated_at: null,
    voltage: 226.5,
    current: 0.04399999976158142,
    power_active: 8.399999618530273,
    power_apparent: 11.33243179321289,
    power_reactive: 7.199999809265137,
    power_factor: 0.745516836643219,
    phase_angle: 0,
    frequency: 59.880001068115234,
    import_energy_active: 1098.0030517578125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 8.205999374389648,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 8.205999374389648,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.04051331803202629,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1419677734375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 10,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 226.6999969482422,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.376702308654785,\n    "power_reactive": 7.599999904632568,\n    "power_factor": 0.7445177435874939,\n    "phase_angle": 0.0,\n    "frequency": 59.95000076293945,\n    "import_energy_active": 1098.0030517578125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 8.205999374389648,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 8.205999374389648,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.04051331803202629,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.1419677734375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-21T15:28:23.000Z',
    updated_at: null,
    voltage: 226.6999969482422,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.376702308654785,
    power_reactive: 7.599999904632568,
    power_factor: 0.7445177435874939,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 1098.0030517578125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 8.205999374389648,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 8.205999374389648,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0.04051331803202629,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.1419677734375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 11,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.8000030517578,\n    "current": 0.03999999910593033,\n    "power_active": 8.0,\n    "power_apparent": 11.114684104919434,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7491909265518188,\n    "phase_angle": 0.0,\n    "frequency": 60.09000015258789,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:20:48.000Z',
    updated_at: null,
    voltage: 224.8000030517578,
    current: 0.03999999910593033,
    power_active: 8,
    power_apparent: 11.114684104919434,
    power_reactive: 7.199999809265137,
    power_factor: 0.7491909265518188,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 12,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.60000610351562,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.115812301635742,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7574576139450073,\n    "phase_angle": 0.0,\n    "frequency": 60.02000045776367,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:20:54.000Z',
    updated_at: null,
    voltage: 224.60000610351562,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.115812301635742,
    power_reactive: 7.199999809265137,
    power_factor: 0.7574576139450073,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 13,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.39999389648438,\n    "current": 0.03999999910593033,\n    "power_active": 8.399999618530273,\n    "power_apparent": 11.118326187133789,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7626655697822571,\n    "phase_angle": 0.0,\n    "frequency": 60.09000015258789,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:21:00.000Z',
    updated_at: null,
    voltage: 224.39999389648438,
    current: 0.03999999910593033,
    power_active: 8.399999618530273,
    power_apparent: 11.118326187133789,
    power_reactive: 7.199999809265137,
    power_factor: 0.7626655697822571,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 14,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 223.8000030517578,\n    "current": 0.03999999910593033,\n    "power_active": 8.0,\n    "power_apparent": 10.946932792663574,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.755109965801239,\n    "phase_angle": 0.0,\n    "frequency": 60.02000045776367,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:31:24.000Z',
    updated_at: null,
    voltage: 223.8000030517578,
    current: 0.03999999910593033,
    power_active: 8,
    power_apparent: 10.946932792663574,
    power_reactive: 6.800000190734863,
    power_factor: 0.755109965801239,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 15,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 223.89999389648438,\n    "current": 0.03999999910593033,\n    "power_active": 8.0,\n    "power_apparent": 10.960805892944336,\n    "power_reactive": 6.800000190734863,\n    "power_factor": 0.7566066384315491,\n    "phase_angle": 0.0,\n    "frequency": 60.09000015258789,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:31:30.000Z',
    updated_at: null,
    voltage: 223.89999389648438,
    current: 0.03999999910593033,
    power_active: 8,
    power_apparent: 10.960805892944336,
    power_reactive: 6.800000190734863,
    power_factor: 0.7566066384315491,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 16,
    name: 'Room 1',
    model: 'SDM120CT',
    data: '{\n    "voltage": 224.10000610351562,\n    "current": 0.03999999910593033,\n    "power_active": 8.0,\n    "power_apparent": 10.961299896240234,\n    "power_reactive": 7.199999809265137,\n    "power_factor": 0.7469474077224731,\n    "phase_angle": 0.0,\n    "frequency": 60.02000045776367,\n    "import_energy_active": 1098.0069580078125,\n    "export_energy_active": 0.13899999856948853,\n    "import_energy_reactive": 544.3090209960938,\n    "export_energy_reactive": 0.6380000114440918,\n    "total_demand_power_active": 0.0,\n    "maximum_total_demand_power_active": 880.2477416992188,\n    "import_demand_power_active": 0.0,\n    "maximum_import_demand_power_active": 880.2477416992188,\n    "export_demand_power_active": 0.0,\n    "maximum_export_demand_power_active": 139.2559051513672,\n    "total_demand_current": 0.0,\n    "maximum_total_demand_current": 3.857666015625,\n    "total_energy_active": 1098.14599609375,\n    "total_energy_reactive": 544.947021484375\n}',
    created_at: '2022-11-22T13:31:36.000Z',
    updated_at: null,
    voltage: 224.10000610351562,
    current: 0.03999999910593033,
    power_active: 8,
    power_apparent: 10.961299896240234,
    power_reactive: 7.199999809265137,
    power_factor: 0.7469474077224731,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 1098.0069580078125,
    export_energy_active: 0.13899999856948853,
    import_energy_reactive: 544.3090209960938,
    export_energy_reactive: 0.6380000114440918,
    total_demand_power_active: 0,
    maximum_total_demand_power_active: 880.2477416992188,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 880.2477416992188,
    export_demand_power_active: 0,
    maximum_export_demand_power_active: 139.2559051513672,
    total_demand_current: 0,
    maximum_total_demand_current: 3.857666015625,
    total_energy_active: 1098.14599609375,
    total_energy_reactive: 544.947021484375,
  },
  {
    id: 17,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:21:08.306473',
    voltage: 221.6999969482422,
    current: 0,
    power_active: 0,
    power_apparent: 4.649868011474609,
    power_reactive: 4.599999904632568,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.012000000104308128,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11688882857561111,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11688882857561111,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.012000000104308128,
  },
  {
    id: 18,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:36:36.861674',
    voltage: '',
    current: '',
    power_active: '',
    power_apparent: '',
    power_reactive: '',
    power_factor: '',
    phase_angle: '',
    frequency: '',
    import_energy_active: '',
    export_energy_active: '',
    import_energy_reactive: '',
    export_energy_reactive: '',
    total_demand_power_active: '',
    maximum_total_demand_power_active: '',
    import_demand_power_active: '',
    maximum_import_demand_power_active: '',
    export_demand_power_active: '',
    maximum_export_demand_power_active: '',
    total_demand_current: '',
    maximum_total_demand_current: '',
    total_energy_active: '',
    total_energy_reactive: '',
  },
  {
    id: 19,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:44:10.661129',
    voltage: 222.3000030517578,
    current: 0,
    power_active: 0,
    power_apparent: 4.549976348876953,
    power_reactive: 4.5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014000000432133675,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11577770859003067,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11577770859003067,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014000000432133675,
  },
  {
    id: 20,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:45:50.439998',
    voltage: 223,
    current: 0,
    power_active: 0,
    power_apparent: 4.592695713043213,
    power_reactive: 4.5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014000000432133675,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11533326655626297,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11533326655626297,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014000000432133675,
  },
  {
    id: 21,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 02:45:52.135630',
    voltage: 223.10000610351562,
    current: 0,
    power_active: 0,
    power_apparent: 4.506420135498047,
    power_reactive: 4.5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014000000432133675,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11533326655626297,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11533326655626297,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014000000432133675,
  },
  {
    id: 22,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:46:16.525039',
    voltage: 222.5,
    current: 0,
    power_active: 0,
    power_apparent: 4.631246566772461,
    power_reactive: 4.599999904632568,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014000000432133675,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11588882654905319,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11588882654905319,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014000000432133675,
  },
  {
    id: 23,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 02:46:19.347547',
    voltage: 222.5,
    current: 0,
    power_active: 0,
    power_apparent: 5.029020309448242,
    power_reactive: 5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.01600000075995922,
    export_energy_reactive: 0,
    total_demand_power_active: 0.018444446846842766,
    maximum_total_demand_power_active: 3156.6650390625,
    import_demand_power_active: 0.00011111111234640703,
    maximum_import_demand_power_active: 3156.6650390625,
    export_demand_power_active: 0.01833333633840084,
    maximum_export_demand_power_active: 1.7059993743896484,
    total_demand_current: 0.0012444444000720978,
    maximum_total_demand_current: 123.51732635498047,
    total_energy_active: 0,
    total_energy_reactive: 0.01600000075995922,
  },
  {
    id: 24,
    name: 'Room 4',
    model: 'SDM120',
    created_at: '2023-01-13 02:46:27.815847',
    voltage: 223.39999389648438,
    current: 0,
    power_active: 0,
    power_apparent: 5.786940097808838,
    power_reactive: 5.699999809265137,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.019999999552965164,
    export_energy_reactive: 0,
    total_demand_power_active: 0.02133333869278431,
    maximum_total_demand_power_active: 3162.71044921875,
    import_demand_power_active: 0.00033333332976326346,
    maximum_import_demand_power_active: 3162.71044921875,
    export_demand_power_active: 0.021000005304813385,
    maximum_export_demand_power_active: 2803.467529296875,
    total_demand_current: 0.02710000053048134,
    maximum_total_demand_current: 123.62109375,
    total_energy_active: 0,
    total_energy_reactive: 0.019999999552965164,
  },
  {
    id: 25,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:49:59.618735',
    voltage: 221,
    current: 0,
    power_active: 0,
    power_apparent: 4.475983142852783,
    power_reactive: 4.400000095367432,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014000000432133675,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11611104756593704,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11611104756593704,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014000000432133675,
  },
  {
    id: 26,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 02:50:02.444319',
    voltage: 221,
    current: 0,
    power_active: 0,
    power_apparent: 4.992352485656738,
    power_reactive: 4.900000095367432,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.01600000075995922,
    export_energy_reactive: 0,
    total_demand_power_active: 0.01877777837216854,
    maximum_total_demand_power_active: 3156.6650390625,
    import_demand_power_active: 0.00011111111234640703,
    maximum_import_demand_power_active: 3156.6650390625,
    export_demand_power_active: 0.018666667863726616,
    maximum_export_demand_power_active: 1.7059993743896484,
    total_demand_current: 0.0017222223104909062,
    maximum_total_demand_current: 123.51732635498047,
    total_energy_active: 0,
    total_energy_reactive: 0.01600000075995922,
  },
  {
    id: 27,
    name: 'Room 4',
    model: 'SDM120',
    created_at: '2023-01-13 02:50:10.923553',
    voltage: 220.8000030517578,
    current: 0,
    power_active: 0,
    power_apparent: 5.542331218719482,
    power_reactive: 5.5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.020999999716877937,
    export_energy_reactive: 0,
    total_demand_power_active: 0.02322222851216793,
    maximum_total_demand_power_active: 3162.71044921875,
    import_demand_power_active: 0.0004444444493856281,
    maximum_import_demand_power_active: 3162.71044921875,
    export_demand_power_active: 0.02277778461575508,
    maximum_export_demand_power_active: 2803.467529296875,
    total_demand_current: 0.027855556458234787,
    maximum_total_demand_current: 123.62109375,
    total_energy_active: 0,
    total_energy_reactive: 0.020999999716877937,
  },
  {
    id: 28,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 02:55:43.500970',
    voltage: 220.10000610351562,
    current: 0,
    power_active: 0,
    power_apparent: 4.526127815246582,
    power_reactive: 4.5,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.014999999664723873,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11644437164068222,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11644437164068222,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.014999999664723873,
  },
  {
    id: 29,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 02:55:46.323806',
    voltage: 220,
    current: 0,
    power_active: 0,
    power_apparent: 4.897745609283447,
    power_reactive: 4.800000190734863,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.01600000075995922,
    export_energy_reactive: 0,
    total_demand_power_active: 0.017777778208255768,
    maximum_total_demand_power_active: 3156.6650390625,
    import_demand_power_active: 0.00033333332976326346,
    maximum_import_demand_power_active: 3156.6650390625,
    export_demand_power_active: 0.017444444820284843,
    maximum_export_demand_power_active: 1.7059993743896484,
    total_demand_current: 0.0009777776431292295,
    maximum_total_demand_current: 123.51732635498047,
    total_energy_active: 0,
    total_energy_reactive: 0.01600000075995922,
  },
  {
    id: 30,
    name: 'Room 4',
    model: 'SDM120',
    created_at: '2023-01-13 02:55:54.800238',
    voltage: 220.10000610351562,
    current: 0,
    power_active: 0,
    power_apparent: 5.63200569152832,
    power_reactive: 5.599999904632568,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.020999999716877937,
    export_energy_reactive: 0,
    total_demand_power_active: 0.02066667191684246,
    maximum_total_demand_power_active: 3162.71044921875,
    import_demand_power_active: 0.0004444444493856281,
    maximum_import_demand_power_active: 3162.71044921875,
    export_demand_power_active: 0.02022222802042961,
    maximum_export_demand_power_active: 2803.467529296875,
    total_demand_current: 0.02522222325205803,
    maximum_total_demand_current: 123.62109375,
    total_energy_active: 0,
    total_energy_reactive: 0.020999999716877937,
  },
  {
    id: 31,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 03:07:02.744067',
    voltage: 220.5,
    current: 0,
    power_active: 0,
    power_apparent: 4.374068260192871,
    power_reactive: 4.300000190734863,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.02000045776367,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.01600000075995922,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11499994248151779,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11499994248151779,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.01600000075995922,
  },
  {
    id: 32,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 03:07:05.574374',
    voltage: 221,
    current: 0,
    power_active: 0,
    power_apparent: 4.853557586669922,
    power_reactive: 4.800000190734863,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.017000000923871994,
    export_energy_reactive: 0,
    total_demand_power_active: 0.02044444903731346,
    maximum_total_demand_power_active: 3156.6650390625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3156.6650390625,
    export_demand_power_active: 0.02044444903731346,
    maximum_export_demand_power_active: 1.7059993743896484,
    total_demand_current: 0.00024444443988613784,
    maximum_total_demand_current: 123.51732635498047,
    total_energy_active: 0,
    total_energy_reactive: 0.017000000923871994,
  },
  {
    id: 33,
    name: 'Room 4',
    model: 'SDM120',
    created_at: '2023-01-13 03:07:14.044319',
    voltage: 221.10000610351562,
    current: 0,
    power_active: 0,
    power_apparent: 5.747849464416504,
    power_reactive: 5.699999809265137,
    power_factor: 1,
    phase_angle: 0,
    frequency: 60.09000015258789,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.02199999988079071,
    export_energy_reactive: 0,
    total_demand_power_active: 0.016666671261191368,
    maximum_total_demand_power_active: 3162.71044921875,
    import_demand_power_active: 0.00022222222469281405,
    maximum_import_demand_power_active: 3162.71044921875,
    export_demand_power_active: 0.01644444838166237,
    maximum_export_demand_power_active: 2803.467529296875,
    total_demand_current: 0.023177778348326683,
    maximum_total_demand_current: 123.62109375,
    total_energy_active: 0,
    total_energy_reactive: 0.02199999988079071,
  },
  {
    id: 34,
    name: 'Room 1',
    model: 'SDM120',
    created_at: '2023-01-13 03:09:34.722843',
    voltage: 220.60000610351562,
    current: 0,
    power_active: 0,
    power_apparent: 4.490055084228516,
    power_reactive: 4.400000095367432,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.01600000075995922,
    export_energy_reactive: 0,
    total_demand_power_active: 0.11344439536333084,
    maximum_total_demand_power_active: 3160.162353515625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3160.162353515625,
    export_demand_power_active: 0.11344439536333084,
    maximum_export_demand_power_active: 2574.00927734375,
    total_demand_current: 0,
    maximum_total_demand_current: 123.32218170166016,
    total_energy_active: 0,
    total_energy_reactive: 0.01600000075995922,
  },
  {
    id: 35,
    name: 'Room 2',
    model: 'SDM120',
    created_at: '2023-01-13 03:09:37.543684',
    voltage: 220.5,
    current: 0,
    power_active: 0,
    power_apparent: 4.916056156158447,
    power_reactive: 4.900000095367432,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.95000076293945,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.017000000923871994,
    export_energy_reactive: 0,
    total_demand_power_active: 0.02111111767590046,
    maximum_total_demand_power_active: 3156.6650390625,
    import_demand_power_active: 0,
    maximum_import_demand_power_active: 3156.6650390625,
    export_demand_power_active: 0.02111111767590046,
    maximum_export_demand_power_active: 1.7059993743896484,
    total_demand_current: 0.000744444434531033,
    maximum_total_demand_current: 123.51732635498047,
    total_energy_active: 0,
    total_energy_reactive: 0.017000000923871994,
  },
  {
    id: 36,
    name: 'Room 4',
    model: 'SDM120',
    created_at: '2023-01-13 03:09:46.034675',
    voltage: 220.1999969482422,
    current: 0,
    power_active: 0,
    power_apparent: 5.622159004211426,
    power_reactive: 5.599999904632568,
    power_factor: 1,
    phase_angle: 0,
    frequency: 59.880001068115234,
    import_energy_active: 0,
    export_energy_active: 0,
    import_energy_reactive: 0.023000000044703484,
    export_energy_reactive: 0,
    total_demand_power_active: 0.015222224406898022,
    maximum_total_demand_power_active: 3162.71044921875,
    import_demand_power_active: 0.00022222222469281405,
    maximum_import_demand_power_active: 3162.71044921875,
    export_demand_power_active: 0.015000002458691597,
    maximum_export_demand_power_active: 2803.467529296875,
    total_demand_current: 0.02477777563035488,
    maximum_total_demand_current: 123.62109375,
    total_energy_active: 0,
    total_energy_reactive: 0.023000000044703484,
  },
];
